<script>
export default {
  name: 'jsxTemplate',
  props: ['jsxRender'],
  render() {
    return this.jsxRender
  },
}
</script>
